import React from 'react';
// import {Year2018, Year2020} from './Content';
// import { useParams } from 'react-router';
// import {Link} from "react-router-dom";
// import { GlobalContext } from '../../Contexts/GlobalContext';

const Section1 = () => {


    return (

        <>
            <div className="celebratingAlumni">
                <div className="row">
                    <div className="col-12">

                    </div>
                </div>
            </div> 
        </>
    );

}

export default React.memo(Section1);